import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { withRouter, useParams } from "react-router-dom";
// import ReactPixel from "react-facebook-pixel";

import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";

import MobileWrapper from "componentsCustom/Mobile/MobileWrapper.js";
import TelephoneInput from "componentsCustom/TelephoneInput/TelephoneInput.js";
import CustomInput from "components/CustomInput/CustomInput.js";
// import { PIXEL_ID } from "util/constants.js";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";
import { verifyNumber, verifyEmail } from "util/verifyField.js";
import SidebarCart from "container/view/SidebarCartContainer.js";
import styles from "./Contacts.module.css";

const useStyles = makeStyles(shippingAddressStyle);

function Contacts(props) {
  const {
    // language,
    shippingInfo,
    updateShippingInfo,
    history,
    customStyle,
  } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const formRef = useRef(null);

  const { home } = useParams();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  //const [card, setCard] = useState("");

  const [email, setEmail] = useState("");

  const [prefix, setPrefix] = useState("+39");
  const [telephone, setTelephone] = useState("");

  const [error, setError] = useState({
    firstName: {
      error: false,
      helperText: "",
    },
    lastName: {
      error: false,
      helperText: "",
    },
    email: {
      error: false,
      helperText: "",
    },
    telephone: {
      error: false,
      helperText: "",
    },
  });

  useEffect(() => {
    if (shippingInfo) {
      if (shippingInfo.firstName) {
        setFirstName(shippingInfo.firstName);
      }
      if (shippingInfo.lastName) {
        setLastName(shippingInfo.lastName);
      }
      if (shippingInfo.email) {
        setEmail(shippingInfo.email);
      }
      if (shippingInfo.prefix) {
        setPrefix(shippingInfo.prefix);
      }
      // if (shippingInfo.card) {
      //   setCard(shippingInfo.card);
      // }
      if (shippingInfo.telephone) {
        setTelephone(shippingInfo.telephone);
      }
    }
  }, [props, shippingInfo]);

  function formIsValid() {
    return (
      firstName && lastName && verifyNumber(telephone) && verifyEmail(email)
    );
  }

  const isValid = formIsValid();

  function updateInfo() {
    const copyShippingInfo = Object.assign({}, shippingInfo, {
      firstName,
      lastName,
      //card,
      email: email.trim(),
      telephone,
    });
    updateShippingInfo(copyShippingInfo);
  }

  function onClickContinue() {
    if (isValid) {
      updateInfo();

      //We cannot simply push the path as we have the home page as last parameter of the URL
      var url = history.location.pathname;
      url = url.slice(0, url.lastIndexOf("/"));
      url = url.slice(0, url.lastIndexOf("/")) + "/information/" + home;

      history.replace(url);
    } else {
      formRef.current.scrollIntoView();
      const copyError = { ...error };
      if (!firstName) {
        copyError.firstName = {
          error: true,
          helperText: t("contacts.error_firstName"),
        };
      }
      if (!lastName) {
        copyError.lastName = {
          error: true,
          helperText: t("contacts.error_lastName"),
        };
      }
      if (!verifyNumber(telephone)) {
        copyError.telephone = {
          error: true,
          helperText: t("shippingAddress.error_telephoneDelivery"),
        };
      }
      if (!verifyEmail(email)) {
        copyError.email = {
          error: true,
          helperText: t("contacts.error_email"),
        };
      }
      setError(copyError);
    }
  }

  function removeErrorField(key) {
    if (error && error[key] && error[key].error) {
      const copyError = { ...error };
      copyError[key] = {
        error: false,
        helperText: "",
      };
      setError(copyError);
    }
  }

  const componentsContent = (
    <div ref={formRef} className={classes.container}>
      <Card className={classes.card}>
        <CardBody>
          <Button
            round
            size="sm"
            color="transparent"
            className={classes.buttonBack}
            // style={styles.backSweetAlertStyle}
            onClick={() => {
              var url = history.location.pathname;
              url = url.slice(0, url.lastIndexOf("/"));
              url = url.slice(0, url.lastIndexOf("/")) + "/shop/" + home;

              history.replace(url);
            }}
          >
            <span
              className={classes.buttonText}
              style={{ fontSize: "11px", paddingLeft: "6px" }}
            >
              <ArrowBackIosIcon style={{ marginRight: 0 }} />
            </span>
          </Button>
          <CardHeader>
            <h1 className={classes.title}>{t("contacts.title")}</h1>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6} lg={6}>
                <CustomInput
                  labelText={t("contacts.first_name")}
                  inputProps={{
                    value: firstName || "",
                    autoComplete: "off",
                    onChange: (e) => {
                      removeErrorField("firstName");
                      setFirstName(e.target.value);
                    },
                  }}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  error={
                    error && error.firstName && error.firstName.error
                      ? error.firstName.error
                      : false
                  }
                  helperText={
                    error && error.firstName && error.firstName.helperText
                      ? error.firstName.helperText
                      : ""
                  }
                />
              </GridItem>
              <GridItem xs={12} sm={6} md={6} lg={6}>
                <CustomInput
                  labelText={t("contacts.last_name")}
                  inputProps={{
                    value: lastName || "",
                    autoComplete: "off",
                    onChange: (e) => {
                      removeErrorField("lastName");

                      setLastName(e.target.value);
                    },
                  }}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  error={
                    error && error.lastName && error.lastName.error
                      ? error.lastName.error
                      : false
                  }
                  helperText={
                    error && error.lastName && error.lastName.helperText
                      ? error.lastName.helperText
                      : ""
                  }
                />
              </GridItem>
              <GridItem xs={12} sm={12} md={12} lg={12}>
                <CustomInput
                  labelText={t("contacts.email")}
                  inputProps={{
                    value: email || "",
                    autoComplete: "off",
                    onChange: (e) => {
                      removeErrorField("email");

                      setEmail(e.target.value.trim());
                    },
                  }}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  error={
                    error && error.email && error.email.error
                      ? error.email.error
                      : false
                  }
                  helperText={
                    error && error.email && error.email.helperText
                      ? error.email.helperText
                      : ""
                  }
                />
              </GridItem>
              <TelephoneInput
                prefix={prefix}
                onChangePrefix={(e) => {
                  setPrefix(e);
                }}
                labelText={t("contacts.phone")}
                onChange={(e) => {
                  removeErrorField("telephone");
                  setTelephone(e);
                }}
                telephone={telephone}
                error={error}
              />
              {/* <GridItem xs={12}>
                <CustomInput
                  labelText={t("contacts.card")}
                  inputProps={{
                    value: card || "",
                    autoComplete: "off",
                    onChange: (e) => {
                      // removeErrorField("card");
                      setCard(e.target.value);
                    },
                  }}
                  formControlProps={{
                    fullWidth: true,
                  }}
                />
              </GridItem> */}
            </GridContainer>
          </CardBody>
        </CardBody>
        {/* ******* WEB >= 960 ********** */}
        <Hidden smDown implementation="css">
          {/* {componentsContent} */}
          <div className={classes.containerButtons}>
            <GridContainer>
              <GridItem
                xs={8}
                sm={6}
                md={6}
                lg={6}
                style={{ textAlign: "right" }}
              >
                {/* <Link to={`museum/${home}`}> */}
                <Button
                  round
                  size="sm"
                  onClick={() => {
                    var url = history.location.pathname;
                    url = url.slice(0, url.lastIndexOf("/"));
                    url = url.slice(0, url.lastIndexOf("/")) + "/shop/" + home;

                    history.replace(url);
                  }}
                  style={{
                    backgroundColor: customStyle.buttonBackToMenu,
                  }}
                >
                  <span className={classes.buttonTextNormal}>
                    {t("shippingAddress.back_menu")}
                  </span>
                </Button>
                {/* </Link> */}
              </GridItem>
              <GridItem xs={8} sm={6} md={6} lg={6}>
                <Button
                  round
                  size="sm"
                  color="warning"
                  // className={classes.buttonBig}
                  // color="info"
                  onClick={onClickContinue}
                  style={{
                    backgroundColor: customStyle.buttonContinue,
                  }}
                >
                  <span className={classes.buttonTextNormal}>
                    {t("shippingAddress.continue")}
                  </span>
                </Button>
              </GridItem>
            </GridContainer>
          </div>
        </Hidden>
      </Card>
    </div>
  );

  return (
    <>
      <MobileWrapper
        type={"contacts"}
        showButtons
        containerMobileButton={classes.containerMobileButtonMenu}
        containerClasses={classes.contactsContainer}
        buttons={[
          {
            onClick: onClickContinue,
            color: "warning",
            text: t("shippingAddress.continue"),
            isActive: true,
            isLinkActive: !!isValid,
            path: `information`,
            customStyle: { backgroundColor: customStyle.buttonAction },
          },
          {
            onClick: () => {},
            color: "whiteRed",
            text: t("shippingAddress.back_menu"),
            isActive: true,
            path: `../shop`,
            classNameText: classes.buttonBigTextMenu,
            customColor: customStyle.buttonAction,
          },
        ]}
      >
        <div className={styles.sidenavContainer}>
          <SidebarCart showGoToCheckout={false} />
        </div>

        <div className={styles.contentContainer}>
          {componentsContent}
          {/* <div className="logo_emma">
            <img src={logo} alt="logo" />
          </div> */}
        </div>
      </MobileWrapper>
    </>
  );
}

Contacts.propTypes = {
  language: PropTypes.string.isRequired,
  updateShippingInfo: PropTypes.func.isRequired,
  shippingInfo: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    //card: PropTypes.string,
    email: PropTypes.string,
    prefix: PropTypes.string,
    telephone: PropTypes.string,
  }),
  customStyle: PropTypes.object,
  history: PropTypes.any,
};
Contacts.defaultProps = {
  shippingInfo: {},
  customStyle: {},
  history: null,
};

export default withRouter(Contacts);
